import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
  readonly minHeight?: string | number
}

/** Route guard / session bootstrap — full-viewport shell placeholder. */
export function AuthBootstrapSkeleton({
  testId = 'auth-bootstrap-skeleton',
  minHeight = '100vh',
}: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading"
      sx={{
        minHeight,
        px: { xs: 2, md: 4 },
        py: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Skeleton variant="rounded" height={48} sx={{ ...skeletonRoundedSx, maxWidth: 320 }} />
      <Skeleton variant="rounded" height={160} sx={{ ...skeletonRoundedSx, maxWidth: 960, width: '100%' }} />
      <Skeleton variant="rounded" height={240} sx={{ ...skeletonRoundedSx, maxWidth: 960, width: '100%' }} />
    </Box>
  )
}
